import React from 'react'
import { FormattedHTMLMessage } from 'sb-react-intl'

import messages from './messages'
import s from './FooterCopyright.scss'


const year = new Date().getFullYear()

const FooterCopyright = () => (
  <FormattedHTMLMessage
    className={s.copyright}
    tag="div"
    {...messages.copyrights}
    values={{ year }}
  />
)


export default FooterCopyright
